var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        {
          key: item.stationCode,
          ref: item.stationCode + "Ref",
          refInFor: true,
          staticClass:
            "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
          on: {
            click: function ($event) {
              return _vm.liClickEvent($event, item)
            },
          },
        },
        [
          _vm._m(0, true),
          _c(
            "div",
            { staticClass: "p-relative d-table-cell v-a-middle h-100-p" },
            [
              _c(
                "p",
                {
                  staticClass: "t-ellipsis l-h-1-6-em",
                  staticStyle: { "white-space": "inherit" },
                  style: { width: _vm.listWidth - 40 + "px" },
                },
                [
                  _vm._v(_vm._s(item.stationName) + " "),
                  _c("span", { staticClass: "f-s-12" }, [
                    _vm._v(_vm._s(item.stationCode)),
                  ]),
                ]
              ),
              _c("img", {
                staticClass: "p-absolute top-27 right-10 user-select-none",
                attrs: {
                  src: require("@/assets/images/im/arrow-right.svg"),
                  width: "12",
                },
              }),
            ]
          ),
          _c(
            "im-popover",
            {
              ref: item.stationCode + "PointRef",
              refInFor: true,
              attrs: {
                "target-parent-ref": _vm.$refs,
                "target-ref-name": item.stationCode + "Ref",
                "z-index": "20",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.loading,
                      expression: "item.loading",
                    },
                  ],
                  staticStyle: { "text-align": "center", padding: "5px" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/im/loading_button.gif"),
                      width: "16",
                    },
                  }),
                ]
              ),
              _c(
                "ul",
                {
                  staticClass: "o-auto",
                  staticStyle: { "max-height": "300px" },
                },
                [
                  item.children.length === 0 && !item.loading
                    ? _c(
                        "li",
                        { staticClass: "f-s-12 t-a-center p-y-5 c-g-500" },
                        [_vm._v("暂无数据")]
                      )
                    : _vm._e(),
                  _vm._l(item.children, function (itemb, indexb) {
                    return _c(
                      "li",
                      {
                        key: itemb.userCode,
                        staticClass:
                          "p-x-10 p-y-5 cursor-default b-b b-c-g-100 bg-g-50-hover",
                        class: {
                          "b-b-w-0": indexb === item.children.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.itemClickEvent(itemb)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(itemb.userName) +
                            " " +
                            _vm._s(itemb.userCode) +
                            " " +
                            _vm._s(_vm.getUserRole(itemb))
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-table-cell v-a-middle h-100-p w-64" }, [
      _c(
        "span",
        {
          staticClass:
            "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none b",
          staticStyle: {
            "background-color": "#ecf3fa",
            "border-color": "#a0caf7",
          },
        },
        [
          _c("img", {
            staticClass: "m-t-5 w-24",
            attrs: { src: require("@/assets/images/im/org_icon.svg") },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }